import { render, staticRenderFns } from "./NuevoEmpresa.vue?vue&type=template&id=4b40dd29&"
import script from "./NuevoEmpresa.vue?vue&type=script&lang=js&"
export * from "./NuevoEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports